import { createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from "../../components/app-toast";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import { APP_PATH } from "../../api/backendPath";
import { ACTIONS_APPROVE_CLAIM_ITEM } from "../../action-types/actions";

export const approveClaimItem = createAsyncThunk(
  ACTIONS_APPROVE_CLAIM_ITEM.approveClaimItem,
  async (
    { claimId, item_id, reason, co_payment_percentage },
    { rejectWithValue },
  ) => {
    const axiosPrivate = await useAxiosPrivate();

    try {
      const response = await axiosPrivate.post(
        `${process.env.REACT_APP_API_URL}${APP_PATH.claimsApproveItem.replace(
          "{claimId}",
          claimId,
        )}`,
        {
          item_id,
          reason,
          co_payment_percentage,
        },
      );

      if (response?.data?.status === true || response?.status === 200) {
        toast.success("Claim item approved successfully");
        return response.data;
      } else {
        toast.error(response?.data?.message || "Failed to approve claim item");
        return rejectWithValue(response.data);
      }
    } catch (error) {
      console.error("Approve claim item error:", error);
      const errMsg =
        error?.response?.data?.message ||
        "Something went wrong while approving claim item";
      toast.error(errMsg);
      return rejectWithValue(errMsg);
    }
  },
);
